import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
// import { AppState } from '@capacitor/app';
import { setLoadingSpinner } from '../actions/shared.action';
import { filter, map, mergeMap, of } from 'rxjs';
import { ROUTER_NAVIGATION, RouterNavigatedAction } from '@ngrx/router-store';
import * as fromCampusAction from '../actions/campus.action'
import { APIResponse } from 'src/app/models/api-response.model';
import { AccountService } from 'src/app/services/account.service';
import { CampusService } from 'src/app/services/campus.service';
import { AppState } from '../app.state';

@Injectable()
export class CampusEffects {

  getCampus$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROUTER_NAVIGATION),
      filter((r : RouterNavigatedAction) => {
        return r.payload.routerState.url.startsWith('/home/campus');
      }),
      mergeMap(() => {
        return this.campusService.getCampus().pipe(
          map((response: APIResponse) => {
            return fromCampusAction.getCampusSuccess({ data: response?.details});
          })
        );
      })
    );
  });

  getBuildings$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROUTER_NAVIGATION),
      filter((r : RouterNavigatedAction) => {
        return r.payload.routerState.url.startsWith('/home/buildings');
      }),
      mergeMap(() => {
        return this.campusService.getBuildings().pipe(
          map((response: APIResponse) => {
            return fromCampusAction.getBuildingsSuccess({ data: response?.details});
          })
        );
      })
    );
  });

  getRooms$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROUTER_NAVIGATION),
      filter((r : RouterNavigatedAction) => {
        return r.payload.routerState.url.startsWith('/home/rooms');
      }),
      mergeMap(() => {
        return this.campusService.getRooms().pipe(
          map((response) => {
            return fromCampusAction.getRoomsSuccess({ data: response?.data ? response : response?.details});
          })
        );
      })
    );
  });

  getCourses$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROUTER_NAVIGATION),
      filter((r : RouterNavigatedAction) => {
        return r.payload.routerState.url.startsWith('/home/course');
      }),
      mergeMap(() => {
        return this.campusService.getCourse().pipe(
          map((response: APIResponse) => {
            return fromCampusAction.getCoursesSuccess({ data: response?.details});
          })
        );
      })
    );
  });

  getDepartments$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROUTER_NAVIGATION),
      filter((r : RouterNavigatedAction) => {
        return r.payload.routerState.url.startsWith('/home/department');
      }),
      mergeMap(() => {
        return this.campusService.getDepartments().pipe(
          map((response: APIResponse) => {
            return fromCampusAction.getDepartmentsSuccess({ data: response?.details});
          })
        );
      })
    );
  });

  getColleges$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROUTER_NAVIGATION),
      filter((r : RouterNavigatedAction) => {
        return r.payload.routerState.url.startsWith('/home/college');
      }),
      mergeMap(() => {
        return this.campusService.getColleges().pipe(
          map((response: APIResponse) => {
            return fromCampusAction.getCollegesSuccess({ data: response?.details});
          })
        );
      })
    );
  });

  constructor(
    private actions$: Actions,
    private campusService: CampusService,
    private store: Store<AppState>,
  ) {}

}
